<template>
	<div class="module_course">
		<course-header :course-id="course.uuid" class="header_course_dashboard"></course-header>
		<div class="row page-content">

		</div>
		<div class="row page-content">
            <div class="col-1"></div>
            <div class="col-8 left-spacer">
                <div class="page-section">
                    <b-table hover :items="items" :fields="fields" :isRowHeader="true">
                        <template slot="name" slot-scope="row">
                            <span style="cursor: pointer;" @click="info(row.item, $event.target)">{{row.value}}</span>
                        </template>
                        <template slot="overallGrade" slot-scope="row">{{row.value}}</template>
                        <!--
                        <template slot="percentCompleted" slot-scope="row">{{row.value}}</template>
                        <template slot="hoursOfActivity" slot-scope="row">{{row.value}}</template>
                        <template slot="satisfaction" slot-scope="row">{{row.value}}</template>
                        -->
                    </b-table>
                </div>
            </div>
        </div>

        <b-modal id="gradeModalInfo" size="lg" centered :title="modalTitle" @hidden="showModalInfo = false" hide-footer>
            <b-row class="dashboard-row">
                <b-col cols="5">
                    <div class="card">
                        <div class="card-header">
                            <span class="icon float-left icon-meter text-center mr-2"></span>
                            <span class="label">Performance</span>
                        </div>
                        <div class="card-body">
                            <h5>Current Grade {{ performance }}</h5>
                        </div>
                    </div>
                </b-col>
                <b-col cols="7">
                    <div class="card">
                        <div class="card-header">
                            <span class="icon float-left fa fa-male text-center mr-2"></span>
                            <span class="label">Progress</span>
                        </div>
                    </div>
                    <div class="card-body row progress-chart-conatiner">
                        <b-col cols="6">
                            <div v-if="showModalInfo" class="text-center">
                                <competency-progress-pie :entity-id="uuid" :user-id="userId"></competency-progress-pie>
                            </div>
                            <h6 class="text-center">Competency</h6>
                        </b-col>
                        <b-col cols="6">
                            <div v-if="showModalInfo" class="text-center">
                                <micro-competency-progress-pie :entity-id="uuid" :user-id="userId"></micro-competency-progress-pie>
                            </div>
                            <h6 class="text-center">Micro Competency</h6>
                        </b-col>
                    </div>
                </b-col>
            </b-row>
        </b-modal>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseNav from './CourseNav'
import CourseHeader from './CourseHeader'
import CompetencyProgressPie from './CompetencyProgressPie'
import MicroCompetencyProgressPie from './MicroCompetencyProgressPie'

export default {
  name: 'courseGrade',
  props: ['uuid'],
  components: {
    CourseNav,
    CourseHeader,
    CompetencyProgressPie,
    MicroCompetencyProgressPie
  },
  data: () => {
    return {
      fields: [
        { key: 'name', label: 'Name', 'class': 'text-center' },
        { key: 'performance', label: 'Overall Grade', 'class': 'text-center' }
        // { key: 'percentCompleted', label: '% Completed', 'class': 'text-center' },
        // { key: 'hoursOfActivity', label: 'Hours of Activity', 'class': 'text-center' },
        // { key: 'satisfaction', label: 'Satisfaction', 'class': 'text-center' }
      ],
      userId: '',
      modalTitle: '',
      performance: '0.00%',
      showModalInfo: false
    }
  },

  mounted () {
    this.loadCourseGradeForClass()
  },

  methods: {
    ...mapActions([
      'loadClassGrade'
    ]),

    loadCourseGradeForClass () {
      this.loadClassGrade(this.uuid)
    },

    info (item, index, button) {
      this.userId = item.userId
      this.modalTitle = item.name
      this.performance = item.performance
      this.showModalInfo = true
      this.$root.$emit('bv::show::modal', 'gradeModalInfo', button)
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'classGrades': state => state.course.classGrades
    }),

    items () {
      var grades = []
      for (var i = 0; i < this.classGrades.length; i++) {
        const classGrade = this.classGrades[i]
        const userId = classGrade.userId
        const name = classGrade.firstName + ' ' + classGrade.lastName
        const overallGrade = (classGrade.performance) ? classGrade.performance.toFixed(2) + '%' : '0.00%'
        // const percentCompleted = '40'
        // const hoursOfActivity = '5'
        // const satisfaction = '4'
        // grades[i] = {userId: userId, name: name, performance: overallGrade, percentCompleted: percentCompleted, hoursOfActivity: hoursOfActivity, satisfaction: satisfaction}
        grades[i] = {userId: userId, name: name, performance: overallGrade}
      }
      return grades
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/course/components/ClassGrade.vue